import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d34246a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "?", -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed, inject } from "vue";
import Scene from "@/components/Scene.vue";
import { ModelProviderInjectionInterface, SceneType } from "@/types";
import ParallaxItem from "@/components/wrappers/ParallaxWrapper.vue";
import Loader from "@/components/Loader.vue";
import { modelInjectionKey } from "@/components/providers/injectionKeys";

interface CardsItemInterface {
  active: boolean;
  onClick: () => void;
  picked: boolean;
  prize: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardsItem',
  props: {
    active: { type: Boolean },
    onClick: { type: Function },
    picked: { type: Boolean },
    prize: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  active: boolean;
  onClick: () => void;
  picked: boolean;
  prize: boolean;
};

const cardsItemClassName = "cards-item";

const injectedModels = inject(
  modelInjectionKey
) as ModelProviderInjectionInterface;



const classes = computed(() => [
  cardsItemClassName,
  {
    [`${cardsItemClassName}_active`]: props.active,
    [`${cardsItemClassName}_picked`]: props.picked,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes)),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.onClick && props.onClick(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`${cardsItemClassName}__inner`)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(`${cardsItemClassName}__parallax-item-wrapper`)
      }, [
        _createVNode(ParallaxItem, {
          active: !props.active
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(`${cardsItemClassName}__content`)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`${cardsItemClassName}__text`)
              }, _hoisted_2, 2)
            ], 2)
          ]),
          _: 1
        }, 8, ["active"])
      ], 2),
      _withDirectives(_createVNode(Loader, {
        class: _normalizeClass(`${cardsItemClassName}__loader`)
      }, null, 8, ["class"]), [
        [_vShow, props.active && !_unref(injectedModels).isLoaded.value]
      ]),
      _createVNode(Scene, {
        visible: props.active,
        class: _normalizeClass(`${cardsItemClassName}__scene`),
        type: props.prize ? _unref(SceneType).car : _unref(SceneType).goat
      }, null, 8, ["visible", "class", "type"])
    ], 2)
  ], 2))
}
}

})